// import en from './lang/en'
// import ru from './lang/ru'
import LocalStorage from "../libs/LocalStorage";
import Lib from "@/i18n/lib";

const initalLocale = LocalStorage.getValue(LocalStorage.LOCALE_KEY) || 'ru';

let messages = {[initalLocale]: require('./lang/'+initalLocale)};

export default function(Vue, VueI18n) {
  /**
   * @param choice {number} a choice index given by the input to $tc: `$tc('path.to.rule', choiceIndex)`
   * @param choicesLength {number} an overall amount of available choices
   * @returns a final choice index to select plural word by
   **/
  VueI18n.prototype.getChoiceIndex = function (choice, choicesLength) {
    // this === VueI18n instance, so the locale property also exists here
    if (this.locale !== 'ru') {
      // proceed to the default implementation
      return choice >= choicesLength ? choicesLength - 1 : choice;
    }

    if (choice === 0) {
      return 0;
    }

    const teen = choice > 10 && choice < 20;
    const endsWithOne = choice % 10 === 1;

    if (!teen && endsWithOne) {
      return 1;
    }

    if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
      return 2;
    }

    return (choicesLength < 4) ? 2 : 3;
  };

  Vue.use(VueI18n);

  const i18n = new VueI18n({
    locale: initalLocale,
    messages
  });

// Hot updates
  if (module.hot) {
    module.hot.accept(['./lang/en', './lang/ru'], function () {
      i18n.setLocaleMessage('en', require('./lang/en').default)
      i18n.setLocaleMessage('ru', require('./lang/ru').default)
      // Or the following hot updates via $i18n property
      // app.$i18n.setLocaleMessage('en', require('./en').default)
      // app.$i18n.setLocaleMessage('ja', require('./ja').default)
    })
  }


  Vue.prototype.$locale = {
    change (language) {
      const loadedLanguage = messages[language]!==undefined;
      if (!loadedLanguage) {
        messages[language] = require('./lang/'+language);
        i18n.setLocaleMessage(language, messages[language])
        Lib.afterSetLocaleMessage(language);
      }
      i18n.locale = language;
      LocalStorage.setValue(LocalStorage.LOCALE_KEY, language);
      if (window.$ && window.$.i18n) {
        if (!loadedLanguage) {
          if (window.i18next !== undefined) {
            window.i18next.addResourceBundle(language, 'translation', messages[language]);
          }
        }
        window.$.i18n.init({ lng: language });
        window.$('body').localize();
      }
    },
    current () {
      return i18n.locale;
    }
  };

  // window.$.i18n().load( messages );
  if (window.i18next !== undefined) {
    window.i18next.init({
      lng: initalLocale, // evtl. use language-detector https://github.com/i18next/i18next-browser-languageDetector
      resources: { // evtl. load via xhr https://github.com/i18next/i18next-xhr-backend
        [initalLocale]: {translation: messages[initalLocale]},
        // en: {translation: messages.en},
        // ru: {translation: messages.ru}
      },
      interpolation: {
        prefix: '%{',
        suffix: '}',
      }
    }, function() {
      // for options see
      // https://github.com/i18next/jquery-i18next#initialize-the-plugin
      window.jqueryI18next.init(window.i18next, window.$);

      // start localizing, details:
      // https://github.com/i18next/jquery-i18next#usage-of-selector-function
      window.$('body').localize();
    });
  }

  return i18n;
}
